module.exports = __webpack_public_path__ + "static/media/c2_1.100ef0b8.png";